import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Subject } from 'rxjs';

import { HttpService } from 'src/app/services/http.service';

import { environment } from 'src/environments/environment';

import { io } from 'socket.io-client'

@Injectable({
  providedIn: 'root'
})
export class TrackingService {

  private socket: any = null;
  socketUrl: string = environment.baseUrlSocket;
  socketChanel: string = '';

  constructor(
    private _httpService: HttpService
  ) { }

  // Objetos Observable y Emiters
  private reloadTracking$ = new Subject<boolean>();

  reloadTrackingEmmiter( data: boolean ): void {
    this.reloadTracking$.next(data);
  }

  getSubjetReloadTracking(): Subject<boolean> {
    return this.reloadTracking$;
  }

  getOrder(data: any) {
    let headers = {
      'dataPedido': 'true',
      'clientId': data.clientId
    }
    return this._httpService.httpGet(`compras/compra/${data.orderId}`, headers);
  }

  getStatesOrder(): Observable<any> {
    let userId = localStorage.getItem('uid');
    let clientId = localStorage.getItem('clientId');
    let token = localStorage.getItem('token');
    const observable = new Observable(observer => {
      this.socket = io(this.socketUrl, {
        query: { token },
        transports: ['websocket', 'polling']
      }); 
      this.socket.on(`us_orders_${userId}_cl_${clientId}`, (data: any) => {
        observer.next(data);
      }, (err: any) => console.log(err)
      );
      return () => {
        this.socket.disconnect();
      };
    });

    return observable;
  }

}
